import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ProductProvider } from "./context/ProductContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Admin from "./pages/Admin";
import PublicLayout from "./PublicLayout";
import "./styles/App.css";

function App() {
  return (
    <ProductProvider>
      <Router>
        <Routes>
          {/* Admin route (no navbar/footer) */}
          <Route path="/admin" element={<Admin />} />

          {/* Public routes */}
          <Route
            path="/"
            element={
              <PublicLayout>
                <Home />
              </PublicLayout>
            }
          />

          <Route
            path="/about"
            element={
              <PublicLayout>
                <About />
              </PublicLayout>
            }
          />
        </Routes>
      </Router>
    </ProductProvider>
  );
}

export default App;
